import { createSelector } from 'reselect'
import type { Authentication, Modals } from 'types/Authentication'
export const getAuthentication = (state: Record<string, any>): Authentication =>
  state.authentication || {}
export const getAuthenticationModal = createSelector(
  [getAuthentication],
  ({ authenticationModal }): Modals => authenticationModal || ''
)